
// Types and interfaces
export const TimeSheetNewHeader = [
  "Employee ID",
  "Jumbo Reel",
  "Start Reel",
  "End Reel",
  "Comp Reel",
  "Start time",
  "End time",
  "Duration",
  "Task List",
  "Scope of work",
  "DPX Source In",
  "DPX Source Out",
  "Error Duration",
  "MOV Record In",
  "MOV Record Out",
  "No of Corrections",
  "Types of Correction",
  "Error Code",
  "Error Remarks",
  "Status",
  "Remarks",
  "Actions",
];

export interface TimeSheetEntry {
  emp_id: string;
  jumbo_Reel: string;
  start_Reel: number;
  end_Reel: number;
  comp_Reel: number;
  start_Time: Date;
  end_Time: Date;
  duration: string;
  task: string;
  scope_of_Work: string;
  dpX_Source_In: string;
  dpX_Source_Out: string;
  error_Duration: string;
  moV_Record_In: string;
  moV_Record_Out: string;
  no_of_Corrections: number;
  types_of_Correction: string;
  error_Code: string;
  error_Remarks: string;
  status: string;
  remarks: string;
  actions: string;
}

export interface NewTimeSheetEntry extends TimeSheetEntry {
  id: string;
  projectID: string;
  project_Name: string;
  department: string;
  action_Name: string;
}

export const TIME_SHEET_INITIAL_VALUES:TimeSheetEntry = {
  emp_id: "",
  jumbo_Reel: "",
  start_Reel: 0,
  end_Reel: 0,
  comp_Reel: 0,
  start_Time: new Date(),
  end_Time: new Date(),
  duration: "00:00",
  task: "",
  scope_of_Work: "",
  dpX_Source_In: "",
  dpX_Source_Out: "",
  error_Duration: "",
  moV_Record_In: "",
  moV_Record_Out: "",
  no_of_Corrections: 0,
  types_of_Correction: "",
  error_Code: "",
  error_Remarks: "",
  status: "",
  remarks: "",
  actions: "",
};

export const INITIAL_FORM_DATA: NewTimeSheetEntry = {
  ...TIME_SHEET_INITIAL_VALUES,
  id: "",
  projectID: "",
  project_Name: "",
  department: "",
  action_Name: "",
};


export interface PreviousScopeData {
  id: string;
  task: string;
  scopeOfWork: string;
  frequency: number;
  lastUsed: Date;
}

export interface TaskOption {
  key: string;
  value: string;
  text: string;
}

export interface ScopeItem {
  id: string;
  task: string;
  name: string;
  value: string;
}

export interface Project {
  id: string;
  name: string;
  value: string;
}

export interface TaskListState {
  selected: string;
  options: TaskOption[];
  subtaskList: ScopeItem[];
}

export interface NFAITimeSheetMasteringProps {
  titleLoader: boolean;
  projectList: Project[];
  isUserAuthorized: boolean;
}

export const INITIAL_TASK_LIST: TaskListState = {
  selected: '',
  options: [],
  subtaskList: [],
};

export const statusNewOptions = [
  { key: 'in-progress', value: 'In Progress', text: 'In Progress' },
  { key: 'Complete', value: 'Complete', text: 'Complete' },
  { key: 'Query', value: 'Query', text: 'Query' },
  { key: 'QC 1', value: 'QC 1', text: 'QC 1' },
  { key: 'QC 2', value: 'QC 2', text: 'QC 2' },
  { key: 'QC 3', value: 'QC 3', text: 'QC 3' },
];

export const errorCodeOptions = [
    {
    key: '1',
    text: 'Blue',
    value: 'Blue',
    },
    {
    key: '2',
    text: 'Cream',
    value: 'Cream',
    },
    {
    key: '3',
    text: 'Red',
    value: 'Red',
    },
    {
    key: '4',
    text: 'Green',
    value: 'Green',
    },
]

export interface NFAIProductivityStatusCreate {
  Id: string;
  ProjectId: string;
  Date: Date;
  Emp_ID: string;
  Emp_Name: string;
  jumbo_Reel: string;
  Title: string;
  UCC_ID: string;
  BATCH: string;
  Department: string;
  Total_Reel: string;
  Total_Scanned_Frames: string;
  Total_Duration: string;
  no_of_Corrections: string;
  types_of_Correction: string;
  Type_of_Film: string;
  Task: string;
  Scope_of_work: string;
  Start_Reel: string;
  End_Reel: string;
  Comp_Reel: string;
  Comp_Reel_Frames: string;
  Comp_Reel_Frames_Duration: string;
  Start_time: Date;
  End_time: Date;
  Total_Hours: string;
  DPX_Source_In: string;
  DPX_Source_Out: string;
  Error_Duration: string;
  MOV_Record_In: string;
  MOV_Record_Out: string;
  Error_Code: string;
  Error_Remarks: string;
  Status: string;
  Remarks: string;
  ProductionHours: number;
}

export const initialNFAIProductivityStatusCreate: NFAIProductivityStatusCreate = {
  Id: '',
  ProjectId: '',
  Date: new Date(),
  Emp_ID: '',
  Emp_Name: '',
  jumbo_Reel: '',
  Title: '',
  UCC_ID: '',
  BATCH: '',
  Department: '',
  Total_Reel: '',
  Total_Scanned_Frames: '',
  Total_Duration: '',
  no_of_Corrections: '',
  types_of_Correction: '',
  Type_of_Film: '',
  Task: '',
  Scope_of_work: '',
  Start_Reel: '',
  End_Reel: '',
  Comp_Reel: '',
  Comp_Reel_Frames: '',
  Comp_Reel_Frames_Duration: '',
  Start_time: new Date(),
  End_time: new Date(),
  Total_Hours: '',
  DPX_Source_In: '',
  DPX_Source_Out: '',
  Error_Duration: '',
  MOV_Record_In: '',
  MOV_Record_Out: '',
  Error_Code: '',
  Error_Remarks: '',
  Status: '',
  Remarks: '',
  ProductionHours: 0,
};

export interface QCMarker {
  number: number;
  sourceIn: string;
  sourceOut: string;
  recordDuration: string;
  recordIn: string;
  recordOut: string;
  name: string;
  color: string;
  notes: string;
}